import { useState, useEffect, useRef } from 'react';
import $ from 'jquery';
import 'bootstrap-datepicker';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.standalone.css';
import TopNav from '../components/TopNav';
import Chip from '../components/Chip';
import { walletApi, reportsApi, settingsApi, authApi } from '../services/api';
import { useApp } from '../AppContext';

// ── Wallet Ledger ─────────────────────────────────────────
const LEDGER_PAGE_SIZE = 10;

function txnMeta(transType) {
  const t = (transType || '').toLowerCase();
  if (t.includes('top') || t === 'credit')   return { sign: '+', color: 'var(--gr)', chip: 'cg' };
  if (t.includes('refund'))                  return { sign: '+', color: 'var(--bl)', chip: 'cb' };
  if (t.includes('debit') || t.includes('order')) return { sign: '-', color: 'var(--rd)', chip: 'cr' };
  if (t.includes('additional') || t.includes('charge')) return { sign: '-', color: 'var(--am)', chip: 'ca' };
  return { sign: '', color: 'var(--nv)', chip: '' };
}

export function Ledger({ onNavigate }) {
  const { walletBalance, setWalletBalance } = useApp();
  const [txns, setTxns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [typeFilter, setTypeFilter] = useState('');
  const [page, setPage] = useState(1);
  const { fromVal: defFrom, toVal: defTo } = defaultDateRange(12);
  const [fromDate, setFromDate] = useState(defFrom);
  const [toDate, setToDate] = useState(defTo);

  function fetchTxns(from, to) {
    setLoading(true);
    setPage(1);
    walletApi.getWalletTransactions(from, to)
      .then(txnData => setTxns(Array.isArray(txnData) ? txnData : (txnData?.transactions || [])))
      .catch(() => setTxns([]))
      .finally(() => setLoading(false));
  }

  useEffect(() => {
    fetchTxns(defFrom, defTo);
    walletApi.getWalletDetails().then(walletData => {
      const record = Array.isArray(walletData) ? walletData[0] : walletData;
      if (record) setWalletBalance(parseFloat(record.current_balance) || 0);
    }).catch(() => {});
  }, []); // eslint-disable-line

  function clearDateRange() {
    setFromDate('');
    setToDate('');
    setTypeFilter('');
    fetchTxns('', '');
  }

  const uniqueTypes = [...new Set(txns.map(t => t.trans_type).filter(Boolean))];
  const filtered    = typeFilter ? txns.filter(t => t.trans_type === typeFilter) : txns;

  const totalAdded    = txns.filter(t => txnMeta(t.trans_type).sign === '+' && !(t.trans_type || '').toLowerCase().includes('refund'))
                           .reduce((s, t) => s + Number(t.amount || 0), 0);
  const totalSpent    = txns.filter(t => txnMeta(t.trans_type).sign === '-')
                           .reduce((s, t) => s + Number(t.amount || 0), 0);
  const totalRefunded = txns.filter(t => (t.trans_type || '').toLowerCase().includes('refund'))
                           .reduce((s, t) => s + Number(t.amount || 0), 0);

  const totalPages = Math.max(1, Math.ceil(filtered.length / LEDGER_PAGE_SIZE));
  const curPage   = Math.min(page, totalPages);
  const pageItems  = filtered.slice((curPage - 1) * LEDGER_PAGE_SIZE, curPage * LEDGER_PAGE_SIZE);
  const showFrom   = filtered.length === 0 ? 0 : (curPage - 1) * LEDGER_PAGE_SIZE + 1;
  const showTo     = Math.min(curPage * LEDGER_PAGE_SIZE, filtered.length);

  function goTo(p) { setPage(Math.max(1, Math.min(p, totalPages))); }
  function changeFilter(v) { setTypeFilter(v); setPage(1); }

  return (
    <>
      <TopNav currentPage="wallet" onNavigate={onNavigate} />
      <div className="pg">
        <div className="phd">
          <div>
            <div className="ptitle">Wallet & Credit Ledger</div>
            <div className="psub">Full transaction history for your prepaid account</div>
          </div>
          <div className="otabs" style={{ marginBottom: 0, width: 350 }}>
            <div className="otab" style={{ whiteSpace: 'nowrap' }} onClick={() => onNavigate('wallet')}>💰 Add Credits</div>
            <div className="otab on" onClick={() => onNavigate('ledger')}>📒 Ledger</div>
            <div className="otab" onClick={() => onNavigate('invoices')}>📜 Invoices</div>
          </div>
        </div>

        <div className="gr4 mb20">
          <div className="sc"><div className="si si-or">💰</div><div><div className="slbl">Current Balance</div><div className="sval" style={{ fontSize: '20px' }}>₹{walletBalance.toLocaleString('en-IN')}</div></div></div>
          <div className="sc"><div className="si si-gr">➕</div><div><div className="slbl">Total Added</div><div className="sval" style={{ fontSize: '20px' }}>₹{totalAdded.toLocaleString('en-IN')}</div></div></div>
          <div className="sc"><div className="si si-rd">➖</div><div><div className="slbl">Total Spent</div><div className="sval" style={{ fontSize: '20px' }}>₹{totalSpent.toLocaleString('en-IN')}</div></div></div>
          <div className="sc"><div className="si si-bl">🔄</div><div><div className="slbl">Refunded</div><div className="sval" style={{ fontSize: '20px' }}>₹{totalRefunded.toLocaleString('en-IN')}</div></div></div>
        </div>

        <div className="card">
          <div className="chd">
            <div><div className="ctitle">Transaction History</div><div className="csub">{txns.length} total transactions</div></div>
            <div className="flex g8" style={{ flexWrap: 'wrap', alignItems: 'center' }}>
              <label className="flbl" style={{ margin: 0, whiteSpace: 'nowrap' }}>From</label>
              <DmyDatePicker value={fromDate} onChange={setFromDate} placeholder="From" />
              <label className="flbl" style={{ margin: 0, whiteSpace: 'nowrap' }}>To</label>
              <DmyDatePicker value={toDate} onChange={setToDate} placeholder="To" />
              <button className="btn bpri bsm" onClick={() => fetchTxns(fromDate, toDate)}>Apply</button>
              <button className="btn bghost bsm" onClick={clearDateRange}>Clear</button>
              <select className="fsel" value={typeFilter} onChange={e => changeFilter(e.target.value)}>
                <option value="">All Types</option>
                {uniqueTypes.map(t => <option key={t} value={t}>{t}</option>)}
              </select>
            </div>
          </div>

          {loading ? (
            <div className="flex" style={{ justifyContent: 'center', padding: '40px 0' }}><span className="spinner" /></div>
          ) : filtered.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px 0', color: 'var(--g400)', fontSize: '13px' }}>No transactions found.</div>
          ) : (
            <>
              <div className="twrap">
                <table>
                  <thead>
                    <tr>
                      <th>Date & Time</th>
                      <th>Description</th>                     
                      <th>Type</th>
                      <th>Amount</th>
                      <th>Balance After</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pageItems.map((t, i) => {
                      const meta = txnMeta(t.trans_type);
                      return (
                        <tr key={t.trans_id ?? i}>
                          <td className="tdsm">{t.created_on || '—'}</td>
                          <td>
                            <div className="td1">{t.remarks || '—'}</div>
                            {t.reference_type && <div className="tdm">{t.reference_type} {t.reference_id || '—'}</div> }
                           
                          </td>                         
                          <td><Chip label={t.trans_type || '—'} className={meta.chip} /></td>
                          <td style={{ fontWeight: 700, color: meta.color }}>
                            {meta.sign}₹{Number(t.amount || 0).toLocaleString('en-IN')}
                          </td>
                          <td style={{ fontWeight: 700 }}>₹{Number(t.balance_after || 0).toLocaleString('en-IN')}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              <div className="flex jb aic mt16">
                <div className="ts tg">Showing {showFrom}–{showTo} of {filtered.length} transaction{filtered.length !== 1 ? 's' : ''}</div>
                {totalPages > 1 && (
                  <div className="pag">
                    <button className="pgbtn" onClick={() => goTo(curPage - 1)} disabled={curPage === 1}>‹</button>
                    {curPage > 3 && (
                      <>
                        <button className="pgbtn" onClick={() => goTo(1)}>1</button>
                        {curPage > 4 && <span className="pgbtn" style={{ border: 'none', cursor: 'default' }}>…</span>}
                      </>
                    )}
                    {pageRange(curPage, totalPages).map(p => (
                      <button key={p} className={`pgbtn${p === curPage ? ' on' : ''}`} onClick={() => goTo(p)}>{p}</button>
                    ))}
                    {curPage < totalPages - 2 && (
                      <>
                        {curPage < totalPages - 3 && <span className="pgbtn" style={{ border: 'none', cursor: 'default' }}>…</span>}
                        <button className="pgbtn" onClick={() => goTo(totalPages)}>{totalPages}</button>
                      </>
                    )}
                    <button className="pgbtn" onClick={() => goTo(curPage + 1)} disabled={curPage === totalPages}>›</button>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

// ── GST Invoices ──────────────────────────────────────────
const INV_PAGE_SIZE = 10;

function fmt(n) {
  return `₹${Number(n || 0).toLocaleString('en-IN')}`;
}

function encodeFile(name) {
  try { return btoa(unescape(encodeURIComponent(name))); }
  catch { return encodeURIComponent(name); }
}

function pageRange(current, total) {
  const delta = 2;
  const start = Math.max(1, current - delta);
  const end = Math.min(total, current + delta);
  const range = [];
  for (let i = start; i <= end; i++) range.push(i);
  return range;
}

export function Invoices({ onNavigate }) {
  const { addToast } = useApp();
  const [invs, setInvs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [downloading, setDownloading] = useState(null);

  useEffect(() => {
    walletApi.getInvoiceHistory()
      .then(data => {
        const list = Array.isArray(data) ? data : (data?.invoices || []);
        setInvs(list);
        setPage(1);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  async function handleDownload(inv) {
    const key = inv.invoicenumber;
    if (downloading === key) return;
    setDownloading(key);
    try {
      const url = `${process.env.REACT_APP_API_URL}/wallet/DownloadInvoice?file=${encodeFile(inv.invoicenumber)}`;
      const res = await fetch(url, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token') || ''}` },
        credentials: 'include',
      });
      if (!res.ok) throw new Error(`Server error ${res.status}`);
      const blob = await res.blob();
      const objectUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = objectUrl;
      a.download = `${inv.invoicenumber || 'invoice'}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(objectUrl);
    } catch (e) {
      addToast(`Download failed: ${e.message}`, 'error');
    } finally {
      setDownloading(null);
    }
  }

  const totalCredits = invs.reduce((s, i) => s + Number(i.totalamount || 0), 0);
  const totalGst    = invs.reduce((s, i) => s + Number(i.gstamount   || 0), 0);
  const totalPaid   = invs.reduce((s, i) => s + Number(i.payableamount || 0), 0);

  const totalPages  = Math.max(1, Math.ceil(invs.length / INV_PAGE_SIZE));
  const curPage    = Math.min(page, totalPages);
  const pageInvs    = invs.slice((curPage - 1) * INV_PAGE_SIZE, curPage * INV_PAGE_SIZE);
  const showFrom    = invs.length === 0 ? 0 : (curPage - 1) * INV_PAGE_SIZE + 1;
  const showTo      = Math.min(curPage * INV_PAGE_SIZE, invs.length);

  function goTo(p) { setPage(Math.max(1, Math.min(p, totalPages))); }

  return (
    <>
      <TopNav currentPage="wallet" onNavigate={onNavigate} />
      <div className="pg">
        <div className="phd">
          <div>
            <div className="ptitle">GST Invoices</div>
            <div className="psub">All credit top-up invoices — for accounting & GST input credit</div>
          </div>
          <div className="otabs" style={{ marginBottom: 0, width: 350 }}>
            <div className="otab" style={{ whiteSpace: 'nowrap' }} onClick={() => onNavigate('wallet')}>💰 Add Credits</div>
            <div className="otab" onClick={() => onNavigate('ledger')}>📒 Ledger</div>
            <div className="otab on" onClick={() => onNavigate('invoices')}>📜 Invoices</div>
          </div>
        </div>

        <div className="gr4 mb20">
          <div className="sc"><div className="si si-bl">📄</div><div><div className="slbl">Total Invoices</div><div className="sval">{invs.length}</div></div></div>
          <div className="sc"><div className="si si-gr">💰</div><div><div className="slbl">Credits Purchased</div><div className="sval" style={{ fontSize: '19px' }}>{fmt(totalCredits)}</div></div></div>
          <div className="sc"><div className="si si-or">🏛️</div><div><div className="slbl">GST Paid (18%)</div><div className="sval" style={{ fontSize: '19px' }}>{fmt(totalGst)}</div></div></div>
          <div className="sc"><div className="si si-pu">💳</div><div><div className="slbl">Total Paid (incl. GST)</div><div className="sval" style={{ fontSize: '19px' }}>{fmt(totalPaid)}</div></div></div>
        </div>

        <div className="card">
          <div className="chd">
            <div><div className="ctitle">Invoice History</div><div className="csub">GST invoices raised by cFIRST Background Chekcs LLP.</div></div>
          </div>

          {loading ? (
            <div className="flex" style={{ justifyContent: 'center', padding: '40px 0' }}><span className="spinner" /></div>
          ) : invs.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px 0', color: 'var(--g400)', fontSize: '13px' }}>No invoices found.</div>
          ) : (
            <>
              <div className="twrap">
                <table>
                  <thead>
                    <tr>
                      <th>Invoice No.</th>
                      <th>Date</th>
                      <th>Payment Ref.</th>
                      <th>Credits</th>
                      <th>GST (18%)</th>
                      <th>Total Paid</th>
                      <th>Status</th>
                      <th>Method</th>
                      <th>Download</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pageInvs.map((inv, i) => {
                      const isGenerated = (inv.invoicestatus || '').toUpperCase() === 'GENERATED';
                      const isDownloading = downloading === inv.invoicenumber;
                      const hasPdf = !!(inv.invoicename || inv.invoicenumber);
                      return (
                        <tr key={inv.invoicenumber || i}>
                          <td className="tdmono">{inv.invoicenumber || '—'}</td>
                          <td className="tdsm">{inv.createdon || '—'}</td>
                          <td className="tdmono">{inv.transaction_id || inv.TRANSACTION_ID || '—'}</td>
                          <td className="tdsm" style={{ fontWeight: 700, color: 'var(--or-dk)' }}>{fmt(inv.totalamount)}</td>
                          <td className="tdsm">{fmt(inv.gstamount)}</td>
                          <td style={{ fontWeight: 800 }}>{fmt(inv.payableamount)}</td>
                          <td><Chip label={inv.invoicestatus || '—'} className={isGenerated ? 'ca' : 'cg'} /></td>
                          <td className="tdsm">{inv.invoicetype || '—'}</td>
                          <td>
                            <button
                              className="btn bout bsm"
                              onClick={() => handleDownload(inv)}
                              disabled={!hasPdf || isDownloading}
                              style={!hasPdf ? { opacity: .5 } : undefined}
                            >
                              {isDownloading
                                ? <><span className="spinner" style={{ width: 11, height: 11 }} /> …</>
                                : '⬇ PDF'}
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              <div className="flex jb aic mt16">
                <div className="ts tg">
                  Showing {showFrom}–{showTo} of {invs.length} invoice{invs.length !== 1 ? 's' : ''}
                </div>
                {totalPages > 1 && (
                  <div className="pag">
                    <button className="pgbtn" onClick={() => goTo(curPage - 1)} disabled={curPage === 1}>‹</button>
                    {curPage > 3 && (
                      <>
                        <button className="pgbtn" onClick={() => goTo(1)}>1</button>
                        {curPage > 4 && <span className="pgbtn" style={{ border: 'none', cursor: 'default' }}>…</span>}
                      </>
                    )}
                    {pageRange(curPage, totalPages).map(p => (
                      <button key={p} className={`pgbtn${p === curPage ? ' on' : ''}`} onClick={() => goTo(p)}>{p}</button>
                    ))}
                    {curPage < totalPages - 2 && (
                      <>
                        {curPage < totalPages - 3 && <span className="pgbtn" style={{ border: 'none', cursor: 'default' }}>…</span>}
                        <button className="pgbtn" onClick={() => goTo(totalPages)}>{totalPages}</button>
                      </>
                    )}
                    <button className="pgbtn" onClick={() => goTo(curPage + 1)} disabled={curPage === totalPages}>›</button>
                  </div>
                )}
              </div>
            </>
          )}

          <div className="alert a-bl mt16">
            <div className="aico">ℹ️</div>
            <div className="abody" style={{ fontSize: '11px' }}>GST invoices are issued by cFIRST Background Chekcs LLP. Use these for input tax credit claims.</div>
          </div>
        </div>
      </div>
    </>
  );
}

// ── Monthly Usage Report ──────────────────────────────────
const RPT_PAGE_SIZE = 10;
const MON = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

function isoToDmy(iso) {
  if (!iso) return '';
  const [y, m, d] = iso.split('-');
  return `${d}-${MON[parseInt(m, 10) - 1]}-${y}`;
}

function defaultDateRange(months = 1) {
  const now = new Date();
  const toVal = isoToDmy(now.toISOString().slice(0, 10));
  const from = new Date(now);
  from.setMonth(from.getMonth() - months);
  const fromVal = isoToDmy(from.toISOString().slice(0, 10));
  return { fromVal, toVal };
}

function DmyDatePicker({ value, onChange, placeholder = 'dd-Mon-yyyy' }) {
  const ref = useRef(null);

  useEffect(() => {
    const $input = $(ref.current);
    $input.datepicker({
      format: 'dd-M-yyyy',
      autoclose: true,
      todayHighlight: true,
      orientation: 'bottom auto',
    });
    $input.on('changeDate', () => onChange($input.val()));
    return () => { $input.datepicker('destroy'); $input.off('changeDate'); };
  }, []);

  return (
    <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
      <input
        ref={ref}
        className="fsel"
        type="text"
        readOnly
        defaultValue={value}
        placeholder={placeholder}
        style={{ cursor: 'pointer', paddingRight: 24, width: 'calc(11ch + 36px)' }}
      />
      <span style={{ position: 'absolute', right: 8, cursor: 'pointer', color: 'var(--g400)', pointerEvents: 'none', display: 'flex', alignItems: 'center' }}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
        </svg>
      </span>
    </div>
  );
}

function statusChipClass(status) {
  const s = (status || '').toLowerCase();
  if (s.includes('complet')) return 'cg';
  if (s.includes('progress')) return 'cb';
  if (s.includes('approval')) return 'cr';
  if (s.includes('need')) return 'ca';
  return '';
}

export function Reports({ onNavigate }) {
  const { fromVal: defFrom, toVal: defTo } = defaultDateRange();
  const [fromDate, setFromDate] = useState(defFrom);
  const [toDate, setToDate]     = useState(defTo);
  const [rows, setRows]         = useState([]);
  const [loading, setLoading]   = useState(true);
  const [page, setPage]         = useState(1);
  const [pageSize, setPageSize] = useState(RPT_PAGE_SIZE);

  function fetchData(from, to) {
    setLoading(true);
    setPage(1);
    walletApi.getCandidateWiseBreakdown(from, to)
      .then(data => setRows(Array.isArray(data) ? data : (data?.data || [])))
      .catch(() => setRows([]))
      .finally(() => setLoading(false));
  }

  function changePageSize(v) { setPageSize(Number(v)); setPage(1); }

  function exportToExcel() {
    const esc = v => `"${String(v ?? '').replace(/"/g, '""')}"`;
    const headers = ['Sr.', 'Candidate Name', 'Emp. ID', 'Order Date', 'Completion', 'Base Credits', 'Addl. Charges', 'Total', 'Status'];
    const dataRows = rows.map((r, i) => [
      i + 1,
      esc(r.full_name),
      esc(r.employment_number),
      esc(r.creation_date),
      esc(r.report_completion_date),
      Number(r.base_amount || 0),
      Number(r.additional_charge || 0),
      Number(r.total || 0),
      esc(r.status),
    ].join(','));
    const csv = '﻿' + [headers.join(','), ...dataRows].join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Candidate_Breakdown_${fromDate}_to_${toDate}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  useEffect(() => { fetchData(defFrom, defTo); }, []); // eslint-disable-line

  // Summary totals
  const totalCandidates = rows.length;
  const totalBase  = rows.reduce((s, r) => s + Number(r.base_amount       || 0), 0);
  const totalAddl  = rows.reduce((s, r) => s + Number(r.additional_charge || 0), 0);
  const totalAll   = rows.reduce((s, r) => s + Number(r.total             || 0), 0);

  // Status counts
  const countCompleted  = rows.filter(r => (r.status || '').toLowerCase().includes('complet')).length;
  const countInProgress = rows.filter(r => (r.status || '').toLowerCase().includes('progress')).length;
  const countNeedInfo   = rows.filter(r => (r.status || '').toLowerCase().includes('need')).length;
  const countApproval   = rows.filter(r => (r.status || '').toLowerCase().includes('approval')).length;

  const totalPages = Math.max(1, Math.ceil(rows.length / pageSize));

  // Keep page in bounds whenever data or pageSize changes
  useEffect(() => { // eslint-disable-line
    const max = Math.max(1, Math.ceil(rows.length / pageSize));
    if (page > max) setPage(max);
  }, [rows.length, pageSize]);

  const curPage   = Math.min(page, totalPages);
  const pageItems = rows.slice((curPage - 1) * pageSize, curPage * pageSize);
  const showFrom  = rows.length === 0 ? 0 : (curPage - 1) * pageSize + 1;
  const showTo    = Math.min(curPage * pageSize, rows.length);
  function goTo(p) { setPage(Math.max(1, Math.min(p, totalPages))); }

  const periodLabel = fromDate && toDate ? `${fromDate} to ${toDate}` : '—';

  return (
    <>
      <TopNav currentPage="reports" onNavigate={onNavigate} />
      <div className="pg">
        <div className="phd">
          <div><div className="ptitle">Monthly Usage & Billing Annexure</div><div className="psub">Detailed breakdown of all BGV orders for the selected period</div></div>
          <div className="flex g8 aic" style={{ flexWrap: 'wrap' }}>
            <div className="flex g8 aic">
              <label className="flbl" style={{ margin: 0, whiteSpace: 'nowrap' }}>From</label>
              <DmyDatePicker value={fromDate} onChange={setFromDate} />
              <label className="flbl" style={{ margin: 0, whiteSpace: 'nowrap' }}>To</label>
              <DmyDatePicker value={toDate} onChange={setToDate} />
              <button className="btn bpri" onClick={() => fetchData(fromDate, toDate)} disabled={loading}>
                {loading ? <span className="spinner" style={{ width: 12, height: 12 }} /> : '🔍 Search'}
              </button>
            </div>
            <button className="btn bout" onClick={exportToExcel} disabled={rows.length === 0}>⬇ Export Excel</button>
          </div>
        </div>

        <div className="ubanner" style={{ gridTemplateColumns: 'repeat(5, 1fr)' }}>
          <div className="ubi"><div className="ubl">Period</div><div className="ubv" style={{ fontSize: '13px' }}>{periodLabel}</div></div>
          <div className="ubi"><div className="ubl">Total Candidates</div><div className="ubv or">{totalCandidates}</div></div>
          <div className="ubi"><div className="ubl">Base Credits</div><div className="ubv or">₹{totalBase.toLocaleString('en-IN')}</div></div>
          <div className="ubi"><div className="ubl">Addl. Charges</div><div className="ubv">₹{totalAddl.toLocaleString('en-IN')}</div></div>
          <div className="ubi"><div className="ubl">Total</div><div className="ubv or">₹{(totalBase + totalAddl).toLocaleString('en-IN')}</div></div>
        </div>

        <div className="gr4 mb20">
          <div className="sc"><div className="si si-gr">✅</div><div><div className="slbl">Completed</div><div className="sval">{countCompleted}</div></div></div>
          <div className="sc"><div className="si si-bl">🔄</div><div><div className="slbl">In Progress</div><div className="sval">{countInProgress}</div></div></div>
          <div className="sc"><div className="si si-am">⚠️</div><div><div className="slbl">Need Information</div><div className="sval">{countNeedInfo}</div></div></div>
          <div className="sc"><div className="si si-rd">🔴</div><div><div className="slbl">Approval Needed</div><div className="sval">{countApproval}</div></div></div>
        </div>

        <div className="card">
          <div className="chd">
            <div><div className="ctitle">Candidate-wise Breakdown — {periodLabel}</div><div className="csub">{totalCandidates} candidate{totalCandidates !== 1 ? 's' : ''}</div></div>
          </div>

          {loading ? (
            <div className="flex" style={{ justifyContent: 'center', padding: '40px 0' }}><span className="spinner" /></div>
          ) : rows.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px 0', color: 'var(--g400)', fontSize: '13px' }}>No records found for the selected period.</div>
          ) : (
            <>
              <div className="twrap">
                <table>
                  <thead>
                    <tr>
                      <th>Sr.</th>
                      <th>Ref No.</th>
                      <th>Candidate</th>
                      <th>Emp. ID</th>
                      <th>Order Date</th>
                      <th>Completion</th>
                      <th>Base Credits</th>
                      <th>Addl. Charges</th>
                      <th>Total</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pageItems.map((r, i) => {
                      const globalIdx = (curPage - 1) * pageSize + i;
                      return (
                        <tr key={globalIdx}>
                          <td className="tdsm">{globalIdx + 1}</td>
                          <td className="tdsm">{r.profile_number || '—'}</td>
                          <td className="td1">{r.full_name || '—'}</td>
                          <td className="tdmono">{r.employment_number || '—'}</td>
                          <td className="tdsm">{r.creation_date || '—'}</td>
                          <td className="tdsm">{r.report_completion_date || '—'}</td>
                          <td className="tdsm">₹{Number(r.base_amount || 0).toLocaleString('en-IN')}</td>
                          <td className="tdsm" style={{ color: Number(r.additional_charge) > 0 ? 'var(--rd)' : undefined }}>
                            ₹{Number(r.additional_charge || 0).toLocaleString('en-IN')}
                          </td>
                          <td style={{ fontWeight: 700 }}>₹{Number(r.total || 0).toLocaleString('en-IN')}</td>
                          <td><Chip label={r.status || '—'} className={statusChipClass(r.status)} /></td>
                        </tr>
                      );
                    })}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan={6} style={{ padding: '10px 12px', fontSize: '12.5px', fontWeight: 700, color: 'var(--or-dk)', background: 'var(--or-lt)' }}>
                        TOTAL — {periodLabel} ({totalCandidates} candidate{totalCandidates !== 1 ? 's' : ''})
                      </td>
                      <td style={{ padding: '10px 12px', fontWeight: 800, color: 'var(--or-dk)', background: 'var(--or-lt)' }}>₹{totalBase.toLocaleString('en-IN')}</td>
                      <td style={{ padding: '10px 12px', fontWeight: 800, color: 'var(--rd)', background: 'var(--or-lt)' }}>₹{totalAddl.toLocaleString('en-IN')}</td>
                      <td style={{ padding: '10px 12px', fontWeight: 800, color: 'var(--or-dk)', background: 'var(--or-lt)' }}>₹{totalAll.toLocaleString('en-IN')}</td>
                      <td style={{ background: 'var(--or-lt)' }}></td>
                    </tr>
                  </tfoot>
                </table>
              </div>

              <div className="flex jb aic mt16">
                <div className="flex g8 aic">
                  <span className="ts tg" style={{ whiteSpace: 'nowrap' }}>Rows per page:</span>
                  <select className="fsel" style={{ width: 64 }} value={pageSize} onChange={e => changePageSize(e.target.value)}>
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </select>
                  <span className="ts tg" style={{ whiteSpace: 'nowrap', paddingLeft: 8 }}>Showing {showFrom}–{showTo} of {rows.length}</span>
                </div>
                <div className="pag">
                  <button className="pgbtn" onClick={() => goTo(curPage - 1)} disabled={curPage === 1}>‹</button>
                  {curPage > 3 && (
                    <>
                      <button className="pgbtn" onClick={() => goTo(1)}>1</button>
                      {curPage > 4 && <span className="pgbtn" style={{ border: 'none', cursor: 'default' }}>…</span>}
                    </>
                  )}
                  {pageRange(curPage, totalPages).map(p => (
                    <button key={p} className={`pgbtn${p === curPage ? ' on' : ''}`} onClick={() => goTo(p)}>{p}</button>
                  ))}
                  {curPage < totalPages - 2 && (
                    <>
                      {curPage < totalPages - 3 && <span className="pgbtn" style={{ border: 'none', cursor: 'default' }}>…</span>}
                      <button className="pgbtn" onClick={() => goTo(totalPages)}>{totalPages}</button>
                    </>
                  )}
                  <button className="pgbtn" onClick={() => goTo(curPage + 1)} disabled={curPage === totalPages}>›</button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

// ── Settings ──────────────────────────────────────────────
const SETTING_SECTIONS = ['Company Profile', 'Users & Access', 'Notifications', 'Packages & Pricing', 'API & Integrations', 'Security'];

export function Settings({ onNavigate }) {
  const [activeSection, setActiveSection] = useState('Company Profile');
  const [profileForm, setProfileForm] = useState({ companyName: 'Rajasthan Finserv Pvt. Ltd.', gstin: '08AABCR1234F1Z5', pan: 'AABCR1234F', email: 'rohit.s@rajfinserv.in', mobile: '+91 98100 00000', address: '42, Ashoka Marg, Jaipur 302001', state: 'Rajasthan', pin: '302001' });
  const [notifs, setNotifs] = useState({ orderComplete: true, needInfo: true, approvalNeeded: true, lowBalance: true, inviteExpiring: false, weeklyReport: true });
  const [saving, setSaving] = useState(false);

  function setP(k, v) { setProfileForm(f => ({ ...f, [k]: v })); }

  async function saveProfile() {
    setSaving(true);
    try { await settingsApi.updateProfile(profileForm); } catch (e) {} finally { setSaving(false); }
  }

  return (
    <>
      <TopNav currentPage="settings" onNavigate={onNavigate} />
      <div className="pg">
        <div className="phd"><div><div className="ptitle">Account Settings</div><div className="psub">Manage your company profile, users, and preferences</div></div></div>
        <div className="gr2" style={{ alignItems: 'start', gap: '20px' }}>
          <div style={{ gridColumn: 'span 1', maxWidth: '220px' }}>
            <div className="snav">
              {SETTING_SECTIONS.map(s => (
                <div key={s} className={`sni ${activeSection === s ? 'on' : ''}`} onClick={() => setActiveSection(s)}>
                  {s === 'Company Profile' ? '🏢' : s === 'Users & Access' ? '👥' : s === 'Notifications' ? '🔔' : s === 'Packages & Pricing' ? '📦' : s === 'API & Integrations' ? '🔌' : '🔐'} {s}
                </div>
              ))}
            </div>
          </div>
          <div>
            {activeSection === 'Company Profile' && (
              <div className="scontent">
                <div style={{ fontSize: '14px', fontWeight: 700, color: 'var(--nv)', marginBottom: '16px' }}>Company Profile</div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px 16px' }}>
                  <div className="fg fgfull"><label className="flbl">Company Name</label><input className="inp" value={profileForm.companyName} onChange={e => setP('companyName', e.target.value)} /></div>
                  <div className="fg"><label className="flbl">GSTIN</label><input className="inp" value={profileForm.gstin} onChange={e => setP('gstin', e.target.value)} /></div>
                  <div className="fg"><label className="flbl">PAN</label><input className="inp" value={profileForm.pan} onChange={e => setP('pan', e.target.value)} /></div>
                  <div className="fg"><label className="flbl">Primary Email</label><input className="inp" value={profileForm.email} onChange={e => setP('email', e.target.value)} /></div>
                  <div className="fg"><label className="flbl">Mobile</label><input className="inp" value={profileForm.mobile} onChange={e => setP('mobile', e.target.value)} /></div>
                  <div className="fg fgfull"><label className="flbl">Registered Address</label><textarea className="ta" style={{ minHeight: '60px' }} value={profileForm.address} onChange={e => setP('address', e.target.value)} /></div>
                </div>
                <button className="btn bpri mt16" onClick={saveProfile} disabled={saving}>
                  {saving ? <><span className="spinner" style={{ width: 14, height: 14 }} /> Saving…</> : '💾 Save Changes'}
                </button>
              </div>
            )}
            {activeSection === 'Notifications' && (
              <div className="scontent">
                <div style={{ fontSize: '14px', fontWeight: 700, color: 'var(--nv)', marginBottom: '16px' }}>Notification Preferences</div>
                {[
                  { key: 'orderComplete', label: 'Order completed', desc: 'When a BGV report is ready' },
                  { key: 'needInfo', label: 'Need info from candidate', desc: 'When additional information is required' },
                  { key: 'approvalNeeded', label: 'Additional charge approval needed', desc: 'When cFIRST requests surcharge approval' },
                  { key: 'lowBalance', label: 'Low wallet balance', desc: 'When balance falls below threshold' },
                  { key: 'inviteExpiring', label: 'Invite expiring soon', desc: '24 hours before invite expires' },
                  { key: 'weeklyReport', label: 'Weekly summary report', desc: 'Every Monday morning' },
                ].map(n => (
                  <div key={n.key} className="flex jb aic" style={{ padding: '12px 0', borderBottom: '1px solid var(--g100)' }}>
                    <div><div style={{ fontSize: '13px', fontWeight: 600, color: 'var(--nv)' }}>{n.label}</div><div style={{ fontSize: '11.5px', color: 'var(--g400)', marginTop: '2px' }}>{n.desc}</div></div>
                    <label className="toggle">
                      <input type="checkbox" checked={notifs[n.key]} onChange={e => setNotifs(s => ({ ...s, [n.key]: e.target.checked }))} />
                      <span className="tsl" />
                    </label>
                  </div>
                ))}
                <button className="btn bpri mt16">💾 Save Preferences</button>
              </div>
            )}
            {activeSection === 'Packages & Pricing' && (
              <div className="scontent">
                <div style={{ fontSize: '14px', fontWeight: 700, color: 'var(--nv)', marginBottom: '16px' }}>Package Pricing</div>
                <table>
                  <thead><tr style={{ background: 'var(--nv)' }}><th style={{ padding: '9px 12px', color: '#fff', fontSize: '10.5px' }}>Package</th><th style={{ padding: '9px 12px', color: '#fff', fontSize: '10.5px' }}>Checks Included</th><th style={{ padding: '9px 12px', color: '#fff', fontSize: '10.5px', textAlign: 'right' }}>Base Price</th><th style={{ padding: '9px 12px', color: '#fff', fontSize: '10.5px', textAlign: 'right' }}>GST (18%)</th></tr></thead>
                  <tbody>
                    {[{ name: 'Standard', checks: 'Identity + Address + Criminal', price: 600, gst: 108 }, { name: 'Standard Plus', checks: 'Standard + Education (last 2)', price: 850, gst: 153 }, { name: 'Premium', checks: 'Identity + Address + Education + Employment + Criminal', price: 1200, gst: 216 }, { name: 'Executive', checks: 'Premium + Social Media + Reference Check (2)', price: 2000, gst: 360 }].map(p => (
                      <tr key={p.name} style={{ borderBottom: '1px solid var(--g200)' }}>
                        <td style={{ padding: '10px 12px', fontWeight: 700 }}>{p.name}</td>
                        <td style={{ padding: '10px 12px', color: 'var(--g600)', fontSize: '12px' }}>{p.checks}</td>
                        <td style={{ padding: '10px 12px', textAlign: 'right', fontWeight: 700, color: 'var(--or-dk)' }}>₹{p.price}</td>
                        <td style={{ padding: '10px 12px', textAlign: 'right', color: 'var(--g600)' }}>₹{p.gst}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            {!['Company Profile', 'Notifications', 'Packages & Pricing'].includes(activeSection) && (
              <div className="scontent">
                <div style={{ textAlign: 'center', padding: '40px 0', color: 'var(--g400)' }}>
                  <div style={{ fontSize: '32px', marginBottom: '12px' }}>🔧</div>
                  <div style={{ fontWeight: 600 }}>{activeSection}</div>
                  <div style={{ fontSize: '12px', marginTop: '6px' }}>This section is coming soon</div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

